<template>
  <div class="c-table" ref="planDataTable">
    <el-table
      ref="table"
      class="summary-el-table-styles common-el-table-styles"
      border
      show-summary
      v-loading="loading"
      :height="tableHeight"
      :data="data"
      :summary-method="summary"
      :cell-class-name="cellClassName"
      @selection-change="select"
      @sort-change="sortChange"
      @cell-mouse-enter="rowEnter"
      @cell-mouse-leave="rowLeave"
      @header-dragend="headerDragend"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :header-align="col.headerAlign"
        :sortable="col.sortable"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <span v-if="col.key === 'launchTime'">{{ scope.row[col.key] | datetimeToDay }}</span>
          <span v-else-if="col.key === 'adAccountSimpleName'">
            <div v-if="scope.row.edit">
              <el-input
                placeholder=""
                v-model="scope.row.newAdAccountSimpleName"
                maxlength="15"
                style="width: 100px"
                class="inputStyle"
              ></el-input>
              <Button type="primary" :loading="saving" size="small" @click="edit(scope.row)">
                <span v-if="!saving">确定</span>
              </Button>
              <Button size="small" @click="cancelEdit(scope.row, 'edit')">取消</Button>
            </div>
            <div v-else>
              <el-button type="text">{{ scope.row.adAccountSimpleName }}</el-button>
              <Icon @click="changEdit(scope.row, 'edit')" type="md-create" class="m-edit" size="18" color="#409EFF" />
            </div>
          </span>
          <el-button type="text" v-else-if="col.key === 'adAccountName'" @click.stop="showDetail(scope.row)">
            {{ scope.row[col.key] }}
          </el-button>

          <template v-else-if="['accountDayBudget'].includes(col.key)">
            <div style="display: flex">
              <!-- 查看和修改、删除预约预算 popover -->
              <el-popover v-model="scope.row.showAccountBudgetActionPopover" placement="top" trigger="manual">
                <div style="display: flex; align-items: center">
                  <template v-if="scope.row.isAccountReserveModifyBudget">
                    <span>
                      <span>已设置过定时任务，预算将于次日00:00改为</span>
                      <span v-if="scope.row.bookAccountBudget === 0">不限</span>
                      <span v-else>{{ scope.row.bookAccountBudget }}元</span>
                      &emsp;
                    </span>

                    <el-button type="text" @click="onReserveBudgetRemove(scope.row)">删除</el-button>
                    <el-button type="text" @click="onReserveBudgetModify(scope.row, col.key)">编辑</el-button>
                  </template>

                  <template v-else>
                    <span>未设置定时任务</span>
                    <el-button type="text" @click="onReserveBudgetModify(scope.row, col.key)"> 去设置 </el-button>
                  </template>

                  <el-button type="text" @click="scope.row.showAccountBudgetActionPopover = false">取消</el-button>
                </div>
                <div slot="reference" style="display: flex; margin-right: 5px">
                  <em
                    v-if="scope.row.isAccountReserveModifyBudget"
                    style="color: #1974ff; cursor: pointer"
                    class="el-icon-alarm-clock"
                    @click="scope.row.showAccountBudgetActionPopover = true"
                  >
                  </em>
                  <em v-else style="cursor: pointer" class="el-icon-alarm-clock" @click="scope.row.showAccountBudgetActionPopover = true">
                  </em>
                </div>
              </el-popover>
              <!-- 修改预约预算popover -->
              <el-popover title="修改预约预算" v-model="scope.row.showAccountBudgetEditPopover" placement="top" trigger="manual">
                <div style="display: flex; align-items: center">
                  <el-radio-group v-model="scope.row.reserveBudgetRadio" class="edit-budget">
                    <el-radio :label="0"> 不限 </el-radio>
                    <el-radio :label="1">
                      <el-input-number
                        v-model="scope.row.bookAccountBudgetDup"
                        controls-position="right"
                        :disabled="scope.row.reserveBudgetRadio === 0"
                        :precision="2"
                        :step="1"
                        :min="0"
                        :max="99999999"
                        style="width: 110px"
                      />
                    </el-radio>
                  </el-radio-group>

                  <div>
                    <el-button type="text" @click="onReserveBudgetSave(scope.row)"> 保存 </el-button>
                    <el-button type="text" @click="scope.row.showAccountBudgetEditPopover = false">取消</el-button>
                  </div>
                </div>
              </el-popover>

              <editable-cell
                title="修改预算"
                :text="rowValueFmt(scope.row[col.key])"
                :loading="scope.row.optLoading"
                :show-default-btns="false"
                @change="editBudget(scope.row, col.key)"
                @save="saveBudget(scope.row, col.key)"
              >
                <el-radio-group v-model="scope.row.radioState" class="edit-budget">
                  <el-radio :label="0"> 不限 </el-radio>
                  <el-radio :label="1">
                    <el-input-number
                      v-model="scope.row.newValue"
                      controls-position="right"
                      :disabled="scope.row.radioState === 0"
                      :precision="2"
                      :step="1"
                      :min="0"
                      :max="99999999"
                      style="width: 110px"
                    />
                  </el-radio>
                </el-radio-group>
              </editable-cell>
            </div>
          </template>

          <span
            v-else-if="
              [
                'pv',
                'clickNum',
                'paperUseAmount',
                'giveAmount',
                'amount',
                'newRoleMoney',
                'newDeviceMoney',
                'sumMoney',
                'collectClickNum'
              ].includes(col.key)
            "
            >{{ scope.row[col.key] | toThousands }}</span
          >
          <span
            v-else-if="
              col.key.indexOf('Rate') > -1 ||
              col.key.indexOf('Retain') > -1 ||
              col.key.indexOf('RoleRoi') > -1 ||
              col.key.indexOf('monetizationRoi') > -1 ||
              ['sumRebate'].includes(col.key)
            "
            >{{ scope.row[col.key] | toPercentFixed }}</span
          >
          <span v-else>{{ scope.row[col.key] === null || isEmpty(scope.row[col.key]) ? '-' : scope.row[col.key] }}</span>
        </template>
      </el-table-column>
      <template slot="empty">
        <no-data />
      </template>
    </el-table>

    <BatchBudgetModifyModal
      v-model="budgetModifyModal"
      title="批量修改账户预算"
      :rows.sync="batchModifyRows"
      @results="onShowBatchModifyResults"
      @refresh="$emit('on-refresh')"
    ></BatchBudgetModifyModal>
    <BatchBudgetModifyResultsModal v-model="budgetModifyResultsModal" :list.sync="batchModifyResultList"></BatchBudgetModifyResultsModal>
  </div>
</template>
<script>
import { isEmpty, throttle } from '@/common/js/utils'
import { clone } from '@/common/js/just'
import { adAccountEditBase, modifyAccountBudget } from '@/api/ptom.data.model'
import EditableCell from '@/components/editable-cell/index'
import BatchBudgetModifyModal from './modify-budget-batch/index.vue'
import BatchBudgetModifyResultsModal from './modify-budget-batch/results.vue'
import { batchBudgetModify } from '@/api/convert.model'

export default {
  name: 'planDataTable',
  components: { EditableCell, BatchBudgetModifyModal, BatchBudgetModifyResultsModal },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    columns: {
      type: Array
    },
    summary: {
      type: Function
    }
  },
  computed: {
    tableHeight() {
      return this.height - 45
    }
  },
  data() {
    return {
      budgetModifyModal: false,
      budgetModifyResultsModal: false,
      batchModifyRows: [],
      batchModifyResultList: [],

      planId: 0,
      modifyVal: 0,
      budgeTmp: 0, // 弹窗预算
      selectList: [],
      saving: null
    }
  },
  methods: {
    isEmpty,
    /**
     * @description: 项目批量修改预算弹窗
     */
    showAccountBatchBudgetModal() {
      if (!this.selectList?.length) return this.$Message.info('请选择至少一个计划！')
      this.budgetModifyModal = true
      // modifiedBudgetValue 接收修改后的预算值
      this.batchModifyRows = clone(this.selectList).map((s) => ({
        ...s,
        budgetRadio: s.bookAccountBudget > 0 ? 1 : 0,
        modifiedBudgetValue: null
      }))
    },
    onShowBatchModifyResults(resultRows) {
      this.budgetModifyResultsModal = true
      this.batchModifyResultList = resultRows
    },
    rowValueFmt(val) {
      if (val === null) return '-'
      if (val === 0) return '不限'
      else return val
    },

    // 修改前回显数值或不限
    async editBudget(row, key) {
      // 不限或具体数值radio
      const nolimit = row[key] === 0
      this.$set(row, 'radioState', nolimit ? 0 : 1)
      this.$set(row, 'newValue', row[key] || 0)
    },
    /**
     * @description: 删除预约预算
     */
    onReserveBudgetRemove(row) {
      const params = {
        batch_task_type: 2,
        task_list: [
          {
            biz_type: 1,
            biz_id: row.advertiserId,
            media_id: row.mediaId,
            enable_book: 0
          }
        ]
      }
      batchBudgetModify(params).then((data) => {
        if (data) {
          this.$Message.success('取消预约成功')
          this.$emit('on-refresh')
        }
      })
    },
    /**
     * @description: 修改预约预算
     */
    onReserveBudgetModify(row) {
      this.$set(row, 'showAccountBudgetActionPopover', false)
      this.$set(row, 'showAccountBudgetEditPopover', true)
    },

    onReserveBudgetSave(row) {
      const task = {
        media_id: row.mediaId,
        biz_name: row.adAccountName,
        enable_book: 1,
        plan_id: row.planId,
        biz_type: 1,
        biz_id: row.advertiserId,
        target_budget: row.reserveBudgetRadio === 0 ? 0 : row.bookAccountBudgetDup
      }

      if (row.reserveBudgetRadio === 1) {
        if (Math.abs(row.accountDayBudget - row.bookAccountBudgetDup) < 100) {
          return this.$Message.error('预约预算增减幅度不能小于100')
        }

        if (row.mediaId === 10) {
          if (row.bookAccountBudgetDup < 1000) {
            return this.$Message.error('预约预算不能小于1000')
          }
        } else {
          if (row.bookAccountBudgetDup < 300) {
            return this.$Message.error('预约预算不能小于300')
          }
        }
      }

      batchBudgetModify({
        batch_task_type: 2,
        task_list: [task]
      }).then((data) => {
        if (data) {
          this.$Message.success('修改账号预约预算成功')
          this.$emit('on-refresh')
        }
      })
    },

    saveBudget(row, field) {
      const { newValue, radioState } = row
      if (radioState && !newValue) {
        this.$Message.error('预算不能为空，如设置为‘0’请选择不限！')
        return
      }
      const value = radioState === 1 ? newValue : 0

      modifyAccountBudget({ adAccountId: row.adAccountId, value }).then((data) => {
        if (data) {
          this.$Message.success('修改成功')
          this.$emit('on-refresh')
        }
      })
    },
    select(val) {
      this.selectList = val
    },
    showDetail(row) {
      throttle(() => {
        this.$emit('on-map', row)
      }, 1200)()
    },
    sortChange(column) {
      this.$emit('on-sort', column)
    },
    headerDragend(n, o, column) {
      this.$emit('header-dragend', { n, o, column })
    },
    doLayout() {
      this.$refs.table.doLayout()
    },
    cellClassName({ column }) {
      if (column.property === 'adAccountSimpleName') return 'ad-account-name'
      return ''
    },
    // 鼠标经过显示修改笔
    rowEnter(row) {
      this.$set(row, 'editState', true)
    },
    rowLeave(row) {
      this.$set(row, 'editState', false)
    },

    // 修改账号简称
    edit(row) {
      this.saving = true
      adAccountEditBase({
        id: row.adAccountId,
        adAccountSimpleName: row.newAdAccountSimpleName
      }).then((data) => {
        this.saving = false
        if (data) {
          // 修改成功后更新
          this.$set(row, 'edit', false)
          this.$emit('on-refresh')
        }
      })
    },
    cancelEdit(row, key) {
      this.saving = false
      this.$set(row, key, false)
    },
    // 改变编辑状态
    changEdit(row, key, feild) {
      this.$set(row, 'newAdAccountSimpleName', row.adAccountSimpleName)
      this.$set(row, key, true)
    },
    getSelectList() {
      return this.selectList
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  background-color: #fff;

  /* 表格表头 */
  ::v-deep .el-table {
    .ad-account-name {
      position: relative;

      &:hover {
        .m-edit {
          display: block;
        }
      }
      .m-edit {
        position: absolute;
        right: 5px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        display: none;
      }
    }
  }
}
</style>
